module.exports = __webpack_public_path__ + "static/iyzico-webhook-9caa180d0e267107e189c91e0189addc.png";